import AsyncControl from '@/Controls/AsyncControl';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedGroupLayoutViewModelType from '@/ViewModels/Controls/EmbeddedGroupLayoutViewModel';
import ColumnLayoutType from '@/Controls/ColumnLayout';

export default class EmbeddedGroupLayout extends AsyncControl {

    private ColumnLayout = ComponentManager.getControl<typeof ColumnLayoutType>('ColumnLayout');
    private jQueryControl: JQuery;
    private columnLayout: ColumnLayoutType;

    public constructor(private viewModel: EmbeddedGroupLayoutViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'embeddedgrouplayout',

            controlIdent: this.identifier
        });

        if (this.viewModel.columnLayout != null) {
            this.columnLayout = new this.ColumnLayout(this.viewModel.columnLayout);
            var tuple = this.columnLayout.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('EmbeddedGroupLayout', EmbeddedGroupLayout, 'RADPresentation.HTMLClient.DefaultViewExtensions');